import styled from "styled-components";
import { headerSidePadding, colors, fontSizes, mediaQuery } from "@util/constants";
import { HeaderDesign, MegaNavDesign } from "@util/types";

export const HeaderDesktopWrapper = styled.div<{
  design: HeaderDesign;
  fixed?: boolean;
  minimise: boolean;
  hide: boolean;
}>`
  padding:30px ${headerSidePadding}px;
  display:flex;
  justify-content: space-between ;
  align-items: center;
  z-index: 10;
  transition: .25s padding, .25s background-color;
  ${({ design }) => (design === `transparent` || design == null) && `
    position:absolute;
    width:100%;
    color:${colors.white};
  `}
  ${({ design }) => design === `solid` && `
    color:${colors.primary};
    background-color:#fff;
    position:relative;
  `}
  ${({ design }) => design === `transparentDarkText` && `
    position:absolute;
    width:100%;
    color:${colors.primary};
  `}
  ${({ fixed }) => fixed && `
    position:fixed;
    top:0;
    left:0;
    right: 0;
  `}
  ${({ minimise }) => minimise && `
    padding-top:7.5px;
    padding-bottom:7.5px;
  `}
  ${({ hide }) => hide && `
    display: none;
  `}
  .col-left{
    display:flex;
    align-items:center;
    width:100%;
    max-width:75%;
    .header-logo{
      max-width:120px;
      margin-right:60px;
      width:100%;
      transition:width .25s;
      ${mediaQuery.largeDown}{
        max-width:90px;
      }
    }
  }
  .col-right{
    ${mediaQuery.largeDown}{
      display:flex;
      align-items: center;
    }
  }
  li{
    list-style-type:none;
    a > div{ text-decoration:none;}
  }
  ul.level-one-ul{
    text-align:left;
  }
  li.level-one-li{
    display:inline-block;
    &:not(:last-child){
      margin-right:50px;
      ${mediaQuery.mediumDown}{
        margin-right:15px;
      }
    }
    .level-one-a,
    .a-dropdown{
      &:hover,&.active{
        opacity:0.75;
      }
      &.active{
        svg{
          transform: rotate(180deg);
        }
      }
    }
    .level-one-a{
      color:inherit;
      div{
        color:inherit;
      }
    }
    .a-dropdown{
      display:flex;
      align-items:center;
      cursor:pointer;
      svg{
        margin-left:15px;
        color:inherit;
        transition: .25s transform;
      }
    }
  }
  .instanity-header {
    width: 56%;
    display:flex;
    align-items:center;
    justify-content: space-between;
    max-width:60%;
  }
  .instanity-header-logo {
    max-width:120px;
    margin-right:60px;
    width:100%;
    transition:width .25s;
    ${mediaQuery.largeDown}{
      max-width:90px;
    }
  }
`

export const MegaNavWrapper = styled.div<{
  design: MegaNavDesign;
}>`
  position:absolute;
  background:${colors.lightGrey};
  left:0;
  top:100%;
  width:100%;
  z-index:1;
  ${({ design }) => design === "designBrand" && `
    .mega-nav-inner{
      display:grid;
      grid-template-columns: 1fr auto;
    }
    ul{
      padding: 70px 130px;
      display:grid;
      grid-template-columns:1fr 1fr 1fr;
      grid-gap:7.5px;
    }
    article{
      width:479px;
      min-height:471px;
      height:100%;
      background:${colors.lightGrey};
      position:relative;
      .cta-inner{
        padding:36px 45px;
        color:#fff;
        position:absolute;
        width:100%;
        height:100%;
        left:0;
        top:0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        z-index:1;
        background-color:rgba(0,0,0,0.3);
      }
      h3{
        font-size:32px;
      }
      a{
        font-size:32px;
        > div{
          padding:0;
          border:none;
          display:flex;
          align-items:center;
          svg{
            width: 1em;
            height: 1em;
            font-size: 1em;
          }
          span:last-child{
            right:0;
            transition: .25s transform;
          }
        }
        &:hover{
          opacity:.75;
          > div > span:last-child{
            transform: translateX(10px);
          }
        }
      }
    }

  `}
  ${({ design }) => design === "designPlain" && `
    .mega-nav-inner{
      padding:70px ${headerSidePadding}px;
    }
    ul{
      text-align:center;
      li{
        display:inline-block;
        margin:0 60px;
        > a{
          font-size:${fontSizes.h3.default}px;
          ${mediaQuery.largeDown}{
            font-size:${fontSizes.h3.mobile}px;
          }
          div{
            text-decoration:none;
          }
          &:hover{
            opacity:0.75;
          }
        }
      }
    }
  `}
`